import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.o3l_1.f2();
}
function Aggregate$Companion$_anonymous__cowofk() {
  return createSimpleEnumSerializer('com.lightningkite.lightningdb.Aggregate', values());
}
var Aggregate_Sum_instance;
var Aggregate_Average_instance;
var Aggregate_StandardDeviationSample_instance;
var Aggregate_StandardDeviationPopulation_instance;
function values() {
  return [Aggregate_Sum_getInstance(), Aggregate_Average_getInstance(), Aggregate_StandardDeviationSample_getInstance(), Aggregate_StandardDeviationPopulation_getInstance()];
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.o3l_1 = lazy(tmp_0, Aggregate$Companion$_anonymous__cowofk);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  Aggregate_initEntries();
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var Aggregate_entriesInitialized;
function Aggregate_initEntries() {
  if (Aggregate_entriesInitialized)
    return Unit_instance;
  Aggregate_entriesInitialized = true;
  Aggregate_Sum_instance = Aggregate().d3o('Sum', 0);
  Aggregate_Average_instance = Aggregate().d3o('Average', 1);
  Aggregate_StandardDeviationSample_instance = Aggregate().d3o('StandardDeviationSample', 2);
  Aggregate_StandardDeviationPopulation_instance = Aggregate().d3o('StandardDeviationPopulation', 3);
  Companion_getInstance();
}
var AggregateClass;
function Aggregate() {
  if (AggregateClass === VOID) {
    class $ extends Enum() {
      static d3o(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'Aggregate', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    AggregateClass = $;
  }
  return AggregateClass;
}
function Aggregate_Sum_getInstance() {
  Aggregate_initEntries();
  return Aggregate_Sum_instance;
}
function Aggregate_Average_getInstance() {
  Aggregate_initEntries();
  return Aggregate_Average_instance;
}
function Aggregate_StandardDeviationSample_getInstance() {
  Aggregate_initEntries();
  return Aggregate_StandardDeviationSample_instance;
}
function Aggregate_StandardDeviationPopulation_getInstance() {
  Aggregate_initEntries();
  return Aggregate_StandardDeviationPopulation_instance;
}
//region block: exports
export {
  Aggregate_Sum_getInstance as Aggregate_Sum_getInstancegzwfj16tyqqb,
  Companion_getInstance as Companion_getInstancetl9eamf8zl9j,
};
//endregion

//# sourceMappingURL=Aggregate.mjs.map
